import { h, Component } from 'preact';

class ArrowLongRight extends Component {
  render () {
    const { color, width, height, className = '' } = this.props;

    return (
      <svg width={width} height={height} viewBox="0 0 24 14" version="1.1" className={className}>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g
            id="Artboard-4"
            transform="translate(-451.000000, -364.000000)"
            fill-rule="nonzero"
            fill={color || '#ffffff'}
          >
            <g id="icons8-arrows_long_right" transform="translate(451.000000, 364.000000)">
              <polygon
                id="Shape"
                points="17.1875 0.28125 15.78125 1.71875 20.0625 6 0 6 0 8 20.0625 8 15.78125 12.28125 17.1875 13.71875 23.90625 7"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export default ArrowLongRight;
